<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. قسم التحكم والبحث (يختفي عند الطباعة) -->
    <div class="card mb-4 no-print">
      <div class="card-header bg-primary text-white">
        <h5 class="mb-0">تسجيل ومتابعة غياب الطلاب</h5>
      </div>
      
      <div class="card-body">
        <!-- صف الاختيارات -->
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label fw-bold">الفصل الدراسي</label>
             <select
          @change="getSubjectswithtearm(form.term)"
          v-model="form.term"
          class="form-control" 
        >
          <option value="">اختر الفصل الدراسي</option>
          <option v-for="t in terms" :key="t.id" :value="t">
            {{ t.name }}
          </option>
        </select>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">المادة</label>
            <select v-model="form.subject" class="form-control">
          <option value="">اختر المادة</option>
          <option v-for="s in subjects" :key="s.id" :value="s">
            {{ s.name }}
          </option>
        </select>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">المجموعة</label>
            <select v-model="form.group" class="form-control">
              <option value="">اختر المجموعة</option>
              <option v-for="g in groups" :key="g.id" :value="g.id">
                {{ g.group_name }}
              </option>
            </select>
          </div>
          
          <!-- صف رقم الجلوس -->
          <div class="col-md-12 mt-3">
            <label class="form-label fw-bold">رقم الجلوس</label>
            <div class="input-group">
              <span class="input-group-text bg-light">#</span>
              <input 
                v-model="form.Seating_No" 
                type="number" 
                class="form-control form-control-lg" 
                placeholder="أدخل رقم جلوس الطالب هنا..."
                @keyup.enter="SaveAbsStudent" 
              />
            </div>
          </div>
        </div>

        <!-- الأزرار -->
        <div class="d-flex justify-content-end mt-4 flex-wrap gap-2">
          <button @click="SaveAbsStudent" class="btn btn-primary mx-1 mb-2">
            <i class="fas fa-save"></i> حفظ الغياب
          </button>
          
          <button @click="SaveAbsStudentKh" class="btn btn-danger mx-1 mb-2">
            <i class="fas fa-user-secret"></i> حفظ كـ ورقة خاصة (سرية)
          </button>
          
          <button @click="getStudentWithAbs" class="btn btn-warning text-dark mx-1 mb-2">
            <i class="fas fa-search"></i> استعلام عن الغياب
          </button>
          
          <button @click="print" class="btn btn-info text-white mx-1 mb-2">
            <i class="fas fa-print"></i> طباعة الاستعلام
          </button>
        </div>
      </div>
    </div>

    <!-- رسائل التنبيه -->
    <div v-if="message" class="alert alert-success alert-dismissible fade show mt-3 no-print" role="alert">
      {{ message }}
      <button type="button" class="btn-close" @click="message = ''"></button>
    </div>

    <!-- 2. قسم التقرير (الجدول) - يظهر عند وجود بيانات -->
    <div v-if="absStudent.length > 0" class="print-area" id="printMe">
      
      <!-- ترويسة التقرير (للطباعة) -->
      <div class="report-header mb-4 text-center border-bottom pb-3" >
        <div class="row align-items-center">
          <div class="col-4 text-end">
             <!-- يمكنك إضافة اسم المدرسة هنا من متغيرات الـ Data -->
             <p class="mb-1"><strong>كنترول الامتحانات</strong></p>
          </div>
          <div class="col-4 text-center">
            <h3 class="mb-2">تقرير غياب الطلاب</h3>
            <span class="badge bg-secondary fs-6">{{ form.term ? form.term.name : '' }}</span>
          </div>
          <div class="col-4 text-start">
             <!-- <p class="mb-1"><strong>المادة:</strong> {{ form.subject ? form.subject.name : '---' }}</p>
             <p class="mb-0"><strong>المجموعة:</strong> {{ getGroupName(form.group) }}</p> -->
          </div>
        </div>
      </div>

      <!-- الجدول -->
      <div class="table-responsive">
        <table class="table table-bordered table-hover align-middle text-center">
          <thead class="table-light">
            <tr>
              <th style="width: 15%">رقم الجلوس</th>
              <th style="width: 35%">اسم الطالب</th>
              <th style="width: 15%">عدد مواد الغياب</th>
              <th style="width: 20%">المواد الغائب فيها</th>
              <th style="width: 15%" class="no-print">العمليات</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in absStudent" :key="student.Seating_No">
              <td class="fw-bold fs-5">{{ student.Seating_No }}</td>
              <td class="text-end pe-4">{{ student.Arabic_Name }}</td>
              
              <td>
                <span class="badge rounded-pill bg-dark">{{ student.count_abs }}</span>
              </td>
              
              <td>
                <div class="d-flex flex-wrap justify-content-center gap-1">
                  <span 
                    v-for="(abs, index) in student.absent_subjects" 
                    :key="index" 
                    class="badge bg-danger"
                  >
                    {{ abs.subject_code }}
                  </span>
                </div>
              </td>
           
              <td class="no-print">
                 <button 
                   class="btn btn-outline-danger btn-sm" 
                   type="button" 
                   @click="deleteAbsStudent(form.group ,form.subject ,  student.Seating_No ,form.term)"
                   title="حذف الغياب"
                 > 
                   <i class="fas fa-trash-alt"></i> حذف
                 </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- تذييل التقرير -->
      <div class="report-footer mt-4 text-start text-muted fs-6">
        * تم استخراج هذا التقرير بتاريخ: {{ new Date().toLocaleDateString('ar-EG') }}
      </div>
    </div>
  </div>
</template>









<script>
import api from "../../api/axios";
export default {
  data() {
    return {
      message: "",
      subjects: [],
      terms: [],
      groups: [],
      absStudent: [],

      form: {
        Seating_No: "",
        subject: "",
        term: "",
        group: "",
      },
    };
  },

  mounted() {
    api.get("/getterms").then((res) => {
      this.terms = res.data;
    });

    api.get("/getgroups").then((res) => {
      this.groups = res.data;
    });
  },

  methods: {
    getSubjectswithtearm(id) {
    
      api.get("/getSubject/" + id.id).then((res) => {
        this.subjects = res.data;
        // this.getStudentWithAbs();
      });
    },
    SaveAbsStudent() {
        this.message = null
      api
        .post("save-data-abs-studen", this.form)
        .then((res) => {
          this.message = res.data.message;
          //   this.form.sitting_number = "";
          this.getStudentWithAbs();
        })
        .catch((e) => {
              if (e.response && e.response.status === 404) {
       this.message =  e.response.data.message;
    } else {
        console.log("Other Error:", e);
    }
        });
    },
    SaveAbsStudentKh() {
        this.message = null
      api
        .post("save-data-abs-studen-kh", this.form)
        .then((res) => {
          this.message = res.data.message;
          //   this.form.sitting_number = "";
          this.getStudentWithAbs();
        })
        .catch((e) => {
              if (e.response && e.response.status === 404) {
       this.message =  e.response.data.message;
    } else {
        console.log("Other Error:", e);
    }
        });
    },
    deleteAbsStudent(group , subject , Seating_No , term) {
      console.log(group , subject , Seating_No , term);
      
      api
        .post("deleteAbsStudent", {
            subject: subject,
            term: term,
            Seating_No: Seating_No,
            group: group,
        })
        .then((res) => {
          this.id = res.data;
        //   this.getStudentWithAbs();
        })
        .catch(() => {
          console.log("error Save");
        });
    },
    getStudentWithAbs() {
      api
        .post("/getStudentWithAbs", this.form)
        .then((res) => {
          this.absStudent = res.data;
        })
        .catch((e) => {});
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe", () => {
        console.log("Printing done or got cancelled!");
      });
    },
  },
};
</script>

<style scoped>
.container {
  direction: rtl;
  text-align: right;
}

.report-container {
  width: 100%;
  padding: 20px;
  font-family: "Cairo", sans-serif;
  color: #222;
}

.report-header {
  text-align: center;
  margin-bottom: 25px;
}

.report-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
}

.report-header .sub {
  font-size: 14px;
  color: #555;
}

.table-report {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 15px;
}

.table-report thead {
  background: #f1f1f1;
}

.table-report th {
  padding: 10px 8px;
  text-align: center;
  border: 1px solid #ccc;
  font-weight: 700;
}

.table-report td {
  padding: 9px 6px;
  border: 1px solid #ddd;
  text-align: center;
}

.table-report tbody tr:nth-child(even) {
  background: #fafafa;
}

.table-report tbody tr:hover {
  background: #eef5ff;
}

.footer-note {
  margin-top: 30px;
  text-align: left;
  font-size: 13px;
  color: #777;
}
</style>